export const FETCH_STUDENT_PROFILE_REQUEST = 'FETCH_STUDENT_PROFILE_REQUEST';
export const FETCH_STUDENT_PROFILE_SUCCESS = 'FETCH_STUDENT_PROFILE_SUCCESS';
export const FETCH_STUDENT_PROFILE_FAILURE = 'FETCH_STUDENT_PROFILE_FAILURE';

export const UPDATE_STUDENT_PROFILE_REQUEST = 'UPDATE_STUDENT_PROFILE_REQUEST';
export const UPDATE_STUDENT_PROFILE_SUCCESS = 'UPDATE_STUDENT_PROFILE_SUCCESS';
export const UPDATE_STUDENT_PROFILE_FAILURE = 'UPDATE_STUDENT_PROFILE_FAILURE';

export const UPDATE_STUDENT_DOB_REQUEST = 'UPDATE_STUDENT_DOB_REQUEST';
export const UPDATE_STUDENT_DOB_SUCCESS = 'UPDATE_STUDENT_DOB_SUCCESS';
export const UPDATE_STUDENT_DOB_FAILURE = 'UPDATE_STUDENT_DOB_FAILURE';